import { SxProps, Theme } from '@mui/system';
import ThemeConstants from '../../../../theme/ThemeConstants';

const classes = {
  container: {
    marginBottom: '5px',
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.01)',
    },
  },

  shadowStyle: {
    boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.10)',
  },

  notVisited: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'notification.indicator',
    marginLeft: '5px',
  },

  secondaryText: {
    fontSize: '12px',
    fontWeight: 500,
    color: 'common.grey850',
    paddingLeft: '4px',
  },

  dateText: {
    fontSize: '12px',
    fontWeight: 500,
    color: 'grey.500',
    paddingLeft: '4px',
  },

  priorityDateText: {
    fontSize: '12px',
    fontWeight: 500,
    color: 'grey.850',
    paddingLeft: '4px',
  },

  confirmContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'notification.confirmBg',
    borderRadius: '4px',
    padding: '5px',
    marginTop: '8px',
  },

  confirmText: {
    fontSize: '12px',
    fontWeight: 400,
    color: 'common.grey850',
    paddingLeft: '4px',
  },

  secondaryContainer: {
    display: 'flex',
    marginTop: '8px',
  },

  secondaryIconContainer: {
    marginTop: '2.5px',
  },

  alignCenter: {
    alignItems: 'center',
  },

  itemContainer: {
    display: 'flex',
  },

  image: {
    border: `1px solid ${ThemeConstants.common.border}`,
  },

  imageContain: {
    objectFit: 'contain',
  },

  imageCover: {
    objectFit: 'cover',
  },

  ticker: {
    marginTop: '2px',
  },

  priority: {
    backgroundColor: ThemeConstants.common.priorityBg,
    borderLeft: `3px solid ${ThemeConstants.common.counterRed}`,
  },

  contentContainer: {
    display: 'flex',
    flex: 1,
  },

  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  timestampContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '8px',
    marginLeft: '10px',
  },

  timestamp: {
    color: 'grey.500',
    fontWeight: 400,
    fontSize: 12,
  },

  checkbox: {
    display: 'flex',
    alignSelf: 'flex-start',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    marginLeft: '11px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
